import $ from 'jquery';
import { wp_ajax_url } from '../utils/config';

export function init() {
  // Inputs: focused/filled states
  $('form:not(.search-form)').each(function () {
    const $form = $(this);
    $form.find('input,textarea')
      .on('focus', function () { $(this).parents('.input-wrap,.oneField').addClass('focused'); })
      .on('blur', function () {
        const $t = $(this);
        $t.parents('.input-wrap,.oneField').removeClass('focused');
        $t.parents('.input-wrap,.oneField').toggleClass('filled', $t.val() !== '');
      })
      .each(function () {
        $(this).parents('.input-wrap,.oneField').toggleClass('filled', $(this).val() !== '');
      });
  });

  // FormAssembly behaviors + Ajax submit (preserved)
  $('.formassembly-form').each(function () {
    const $formWrapper = $(this);
    const $form = $formWrapper.find('form');
    const $elapsedTime = $('<input type="hidden" value="" name="tfa_dbElapsedJsTime">').appendTo($form);
    const formTimeStart = Math.floor(new Date().getTime() / 1000);

    $('.formassembly-form .oneField:not([role=group],[role=radiogroup])').addClass('input-wrap');
    $('.formassembly-form input.required').attr('required', true);

    if ($('body').hasClass('stay-updated')) {
      $('#tfa_33-D').addClass('offstate');
      const $radios = $('.formassembly-form input[type=radio]');
      $radios.on('change', function () {
        if ($(this).val() === 'tfa_32') $('#tfa_33-D').removeClass('offstate');
        else $('#tfa_33-D').addClass('offstate');
      });
      $('.formassembly-form #tfa_15').on('change', function () {
        $('#tfa_16-D').toggleClass('offstate');
      }).trigger('change');
    }

    if ($('body').hasClass('request-information')) {
      $('#tfa_16-D').addClass('offstate');
      $('.formassembly-form input[type=radio]').on('change', function () {
        $('#tfa_16-D').removeClass('offstate');
      });
    }

    $form.on('submit', function (e) {
      if ($('body').hasClass('consumer-protection-complaints')) return; // preserve your exception
      e.preventDefault();
      if ($form.hasClass('working')) return false;

      $elapsedTime.val(Math.floor(new Date().getTime() / 1000) - formTimeStart);
      $form.addClass('working');

      $.ajax({
        url: wp_ajax_url,
        data: $form.serialize() + '&action=formassembly_submit&formAction=' + $form.attr('action'),
        method: 'POST',
        dataType: 'json',
      })
      .done((data) => {
        if (data.success === 1) {
          $formWrapper.find('.wFormContainer').velocity('slideUp');
          $formWrapper
            .addClass('success')
            .find('.form-response').removeClass('error')
            .html('<h3>Thank you!</h3><p>Your entry was submitted successfully.</p>');
        } else {
          $formWrapper.find('.form-response').addClass('error').html('<p>Error: ' + data.message + '</p>');
        }
      })
      .fail(() => {
        $formWrapper.find('.form-response').addClass('error')
          .html('<p>There was an error submitting the form. Please try again.</p>');
      })
      .always(() => $form.removeClass('working'));
    });
  });

  // Income verification – Next Page visibility fix – Bandicoot folded in
  function eligibilityIncomeVerificationFormNextPageButton() {
    // Do you live in this building?
    if ($('#tfa_13').val() == 'tfa_14' ||  // tfa_14 = Yes
        // Are you interested in participating in community solar? 
        $('input[name=tfa_266]:radio:checked').val() == 'tfa_267' // tfa_267 = Yes
    ) {  
      $('#wfPageNextId1').show();
    } else {
      $('#wfPageNextId1').hide();
    }
  }
  
  if ($('body.page-template-template-eligibility-verification').length) {
    eligibilityIncomeVerificationFormNextPageButton();
    $(document).on('change','#tfa_13', eligibilityIncomeVerificationFormNextPageButton);
    $(document).on('change','input[name=tfa_266]',eligibilityIncomeVerificationFormNextPageButton);
  }

  // FormAssembly page header tweak – Bandicoot folded in
  if ($('#4653576-WRPR').length) {
    $(document).on('click', '.wfPageNextButton, .wfPagePreviousButton', function() {
      if( $('#wfPgIndex-1').hasClass('wfCurrentPage') ){
        $('.page-header-content p:first').css('display', 'block');
      } else {
        $('.page-header-content p:first').css('display', 'none');
      }
    });
  }
}